module.exports = __webpack_public_path__ + "img/seekingsimple.a484d828.png";